<div class="banner-area relative">
  <div class="container relative z-10">
    <div
      class="flex flex-col lg:flex-row lg:justify-between sm:pt-[193px] justify-center pt-[80px]"
    >
      <!-- Left Content -->
      <div
        class="lg:w-1/2 lg:text-left sm:p-6 w-full px-4 space-y-4 text-center"
      >
        <h1 class="title">
          Interested in getting our
          <span>Fiber Broadband service?</span>
        </h1>
        <p class="details">
        We've got you covered in the Purcellville South area, from Rt 50 to Silcott Springs. We also cover Snickersville area of Philomont, north to Hamilton and Purcellville town limits.
        <br/><br/> We are currently expanding west and south.
        </p>
      </div>

      <!-- Right Form -->
      <div
        class="form-container lg:p-[35px] lg:mx-0 bg-white p-6 shadow-md rounded-lg w-[506px] mx-auto"
      >
        <h2 class="form-title">Inquiring about service?</h2>
        <form
          [formGroup]="registrationForm"
          (ngSubmit)="submitForm()"
          class="flex flex-col lg:space-y-4 space-y-3"
        >
          <!-- Name Inputs -->
          <div class="flex lg:flex-row lg:space-x-4 flex-col mb-3">
            <input
              type="text"
              placeholder="First Name"
              formControlName="firstName"
              pInputText
              class="p-inputtext w-full"
            />
            <input
              type="text"
              placeholder="Last Name"
              formControlName="lastName"
              pInputText
              class="p-inputtext w-full lg:mt-0 mt-3"
            />
          </div>

          <!-- Address Input -->
          <input 
            type="text"
            placeholder="Address"
            formControlName="address"
            pInputText
            class="p-inputtext w-full lg:mt-0 mt-3"/> 
          
        
          <!-- Email Input -->
          <input
            type="text"
            placeholder="Email"
            formControlName="new_email"
            pInputText
            class="p-inputtext w-full"
          />
          <!-- Phone Input -->
          <input
            type="text"
            placeholder="Phone"
            formControlName="phone"
            pInputText
            class="p-inputtext w-full"
          />

          <!-- Radio Group -->
          <div class="space-y-2 mb-4 pb-5">
            <p class="radio-text">
              Is your address EXCLUDED from the Loudoun County VATI Award? *
            </p>
            <div class="flex flex-col space-y-2">
              <label class="flex items-center space-x-2">
                <p-radioButton
                  name="addressStatus"
                  value="yes"
                  formControlName="addressStatus"
                ></p-radioButton>
                <span class="text-sm"
                  >Yes, I have confirmed my address is excluded</span
                >
              </label>
              <label class="flex items-center space-x-2">
                <p-radioButton
                  name="addressStatus"
                  value="no"
                  formControlName="addressStatus"
                ></p-radioButton>
                <span class="text-sm">No</span>
              </label>
              <label class="flex items-center space-x-2">
                <p-radioButton
                  name="addressStatus"
                  value="unsure"
                  formControlName="addressStatus"
                ></p-radioButton>
                <span class="text-sm">I am not sure</span>
              </label>
              <label class="flex items-center space-x-2">
                <p-radioButton
                  name="addressStatus"
                  value="unavailable"
                  formControlName="addressStatus"
                ></p-radioButton>
                <span class="text-sm">Unavailable in your area</span>
              </label>
            </div>
          </div>

          <!-- Submit Button -->
          <button
            type="submit"
            pButton
            label="Submit"
            class="w-full p-button-primary relative z-40"
            [disabled]="registrationForm.invalid"
          ></button>
        </form>
      </div>
    </div>
    <div class="w-full absolute top-[793px] banner-bottom">
      <div class="flex">
        <div class="w-6/12">
          <img src="/images/banner/2.png" alt="banner" class="w-full" />
        </div>
        <div class="w-6/12"></div>
      </div>
    </div>
  </div>
  <div class="absolute top-0 left-0 w-full h-max banner-image">
    <img
      src="/images/banner/1.png"
      alt="banner"
      class="w-full max-h-[850px] object-fill"
    />
  </div>
</div>
